"use client";

import React from 'react';
import StatsCard1 from './StatsCard1';
import StatsCard2 from './StatsCard2';
import StatsCard3 from './StatsCard3';
import { Program } from '@/services/types';
import { StandardLpDocument } from '@/gql/graphql';
import { useGraphQL } from '@/utils/useGraphQL';
import { extractImage } from '@/utils/strapiTojs';
const StatsSectionSPC = ({
  brandLogos,
  filteredLearnerData,
  isMobile
}: {
  brandLogos: {
    image: Image;
  }[];
  studentImages: string[];
  filteredLearnerData: Program | undefined;
  isMobile: boolean;
}) => {
  const statsData = [{
    title: "5000+ learners",
    subtitle: "Have benefitted",
    icon: ""
  }, {
    title: "Our alumni work at top brands in the world",
    subtitle: "upskill and unlock your career potential",
    icon: ""
  }, {
    title: "Learn as you go",
    subtitle: "finish at your own pace",
    icon: `/images/course-diff/papers2${isMobile ? 'm' : ''}.svg`,
    iconStyle: {
      alignSelf: "flex-end",
      marginRight: "-20px",
      marginBottom: "-40px",
      width: "50%",
      height: "auto"
    }
  }, {
    title: "Instant access",
    subtitle: "right after enrolment",
    icon: `/images/course-diff/list${isMobile ? 'm' : ''}.svg`,
    iconStyle: {
      alignSelf: "center",
      marginRight: "-20px",
      marginTop: "-40px",
      marginBottom: "-40px",
      width: "50%",
      height: "auto"
    }
  }, {
    title: "Top industry mentors",
    subtitle: "will guide you through this",
    icon: `/images/course-diff/person-circle${isMobile ? 'm' : ''}.svg`,
    iconStyle: {
      alignSelf: "flex-end",
      marginRight: "-20px",
      marginBottom: "-40px",
      width: "50%",
      height: "auto"
    }
  }];
  const gridDataDesktop = [{
    gridRow: "1",
    gridColumn: "1"
  }, {
    gridRow: "1 / span 2",
    gridColumn: "2"
  }, {
    gridRow: "1",
    gridColumn: "3"
  }, {
    gridRow: "2",
    gridColumn: "1"
  }, {
    gridRow: "2",
    gridColumn: "3"
  }];
  const gridDataMobile = [{
    gridRow: "1",
    gridColumn: "1"
  }, {
    gridRow: "2 / span 2",
    gridColumn: "1"
  }, {
    gridRow: "4",
    gridColumn: "1"
  }, {
    gridRow: "5",
    gridColumn: "1"
  }, {
    gridRow: "6",
    gridColumn: "1"
  }];
  const gridData = isMobile ? gridDataMobile : gridDataDesktop;
  const spanData = [{
    cell: 0,
    cardVariant: 3
  }, {
    cell: 1,
    cardVariant: 2
  }];
  const {
    data: studentData
  } = useGraphQL(StandardLpDocument, {
    productId: filteredLearnerData?.product_id.toString()
  });
  const studentContent = studentData?.standardLps?.data?.[0]?.attributes?.content;
  const studentDataContent = studentContent?.filter(item => item?.__typename === 'ComponentStndardLpLearnerDetail')[0];
  const studentImages = studentDataContent?.Students?.map(student => {
    return extractImage(student?.StudentImage).src;
  });
  return <div className="section__container--small" data-sentry-component="StatsSectionSPC" data-sentry-source-file="StatsSectionSPC.tsx">
      <div className="stats-section">
        {statsData.map((stat, index) => {
        for (let i = 0; i < spanData.length; i++) {
          if (spanData[i].cell === index) {
            switch (spanData[i].cardVariant) {
              case 2:
                return <StatsCard2 key={index} title={stat.title} subtitle={stat.subtitle} icon={stat.icon} gridStyle={gridData[index]} logos={brandLogos} />;
              case 3:
                return <StatsCard3 key={index} title={stat.title} subtitle={stat.subtitle} icon={stat.icon} gridStyle={gridData[index]} logos={brandLogos.map(logo => ({
                  image: logo.image.src
                }))} studentImages={studentImages ?? []} />;
              default:
                return <StatsCard1 key={index} title={stat.title} subtitle={stat.subtitle} icon={stat.icon} iconStyle={stat.iconStyle} gridStyle={gridData[index]} />;
            }
          }
        }
        return <StatsCard1 key={index} title={stat.title} subtitle={stat.subtitle} icon={stat.icon} iconStyle={stat.iconStyle} gridStyle={gridData[index]} />;
      })}
      </div>
    </div>;
};
export default StatsSectionSPC;